import { environment } from '../environments/environment';

export enum PortalVersion {
  EOA = 'EmployerOnlineTool',
  BBP = 'Broker Business Portal',
}

export function getAuth0ClientId() {
  // development logic
  if(document.baseURI.includes('localhost')){
    if(environment.redirectUrlBroker.includes('localhost')){
      return environment.auth0BrokerclientId
    }
    else if (environment.redirectUrlGL.includes('localhost')){
      return environment.auth0GLclientId ;
    }
  }

  if(document.baseURI.includes('broker')){
    return environment.auth0BrokerclientId;
  }
  else{
    return environment.auth0GLclientId ;
  }
}

export function getPortalVersion() : PortalVersion {
  // development logic
  if(document.baseURI.includes('localhost')){
    if(environment.redirectUrlBroker.includes('localhost')){
      return PortalVersion.BBP;
    }
    else if (environment.redirectUrlGL.includes('localhost')){
      return PortalVersion.EOA;
    }
  }

  if(document.baseURI.includes('broker')){
    return PortalVersion.BBP;
  }
  else{
    return PortalVersion.EOA ;
  }
}
